import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
  queryCache: new QueryCache({
    onError: (err) => {
      const msg = err instanceof Error ? err.message : 'Error cargando datos';
      // Evitar toast masivo en cascada — solo cuando hay error real.
      console.error('[query]', msg);
      toast.error('Error cargando datos', { description: msg });
    },
  }),
  mutationCache: new MutationCache({
    // Los mutation onError individuales siguen teniendo prioridad; esto es fallback.
    onError: (err) => {
      console.error('[mutation]', err);
    },
  }),
});
